import React, { useState, useEffect } from "react";
import { Layout, Space, Collapse, Spin, message, Row, Col, Tooltip, Form, Select } from "antd";
import { FiAlignLeft, FiBell, FiUser, FiAlignRight } from "react-icons/fi";
import { authenticationServices } from "services/authenticationServices";

import {
  RiLockPasswordLine,
  RiLogoutCircleRLine,
  RiProfileLine,
  RiMenuLine,
  RiTimeLine,
} from "react-icons/ri";
import ChangePassword from "./components/ChangePassword";
import Profile from "./components/Profile";
import {
  CPModal, CPDropDown, CPButton,
  CPInput,
  CPDivider,
  CPSelect,
  CPTextArea,
} from "components/CP";

// Api
import { userServices } from "services/userServices";
//localization
import { add, edit, title, shop, description, status, action, remove, deleteMessage, yes, no, requiredMessage, close, active, deactivate } from "lang/fa.json"
//Context
import { types, useAdminContext } from 'context/AdminContext'

const { Panel } = Collapse;
const { Option } = Select;

const { Header } = Layout;

const Navigation = ({ collapsed, onCollapse }) => {
  const [showUserPopOver, setShowUserPopOver] = useState(false);
  const [showLangPopOver, setShowLangPopOver] = useState(false);
  const [typeAction, setTypeAction] = useState("");
  const [defaultShop, setDefaultShop] = useState();

  const [openModal, setOpenModal] = useState(false);
  const [userInfo, setUserInfo] = useState("");
  const [shopCodeData, setShopCodeData] = useState("");
  const [listShop, setListShop] = useState([]);

  const [loading, setLoading] = useState(false);
  let { state, dispatch } = useAdminContext();

  const getUserInfo = async () => {
    let user = await authenticationServices.userInfo();
    setUserInfo(user);
  };

  const logoutUser = async () => {
    await authenticationServices.logout();
    setUserInfo("");
  };

  const handleChangeUserDropDown = async (value) => {
    switch (value) {
      case "change_password":
      case "profile":
        setTypeAction(value);
        setOpenModal(true);
        break;
      case "logout":
        logoutUser();
        break;
    }
  };

  const renderModalComponent = (type) => {
    switch (type) {
      case "change_password":
        return (
          <ChangePassword
            loading={loading}
            onCloseModal={() => setOpenModal(false)}
            onSubmit={UpdateChangePasswordUser}
          />
        );
      case "profile":
        return (
          <Profile loading={loading}
            onSubmit={UpdateProfileUser}
            onCloseModal={() => setOpenModal(false)} />
        );
    }
  };

  const renderTitleModal = (type) => {
    switch (type) {
      case "change_password":
        return "تغییر رمزعبور";
      case "profile":
        return "پروفایل";
    }
  };

  const UpdateChangePasswordUser = async (data) => {
    const result = await userServices.changePassword({ ...data });

    if (result.isSuccess) {
      const result = await userServices.changePassword({ ...data });
      message.success(result.message);
      setOpenModal(false);
    } else {
      message.error(result.message);
      setOpenModal(false);

    }

  };

  const UpdateProfileUser = async (data) => {

    const result = await userServices.updateProfileUser(data);

    if (result.isSuccess) {
      message.success(result.message);
      await userServices.getUserForProfileForLocalStorage();
      setOpenModal(false);
    } else {
      message.error(result.message);
      setOpenModal(false);
    }

  };

  let profileUser = JSON.parse(localStorage.getItem('user-profile'));

  useEffect(() => {
    getUserInfo();
  }, []);

  const userInfoDropDown = [
    {
      name: "پروفایل",
      value: "profile",
      icon: <RiProfileLine />,
    },
    {
      name: "تغییر رمز",
      value: "change_password",
      icon: <RiLockPasswordLine />,
    },
    {
      name: "خروج",
      value: "logout",
      href: "/login",
      icon: <RiLogoutCircleRLine />,
    },
  ];
  let sHCS = JSON.parse(localStorage.getItem('SHCS'));
  let tempShops = [];

  for (let index = 0; index < sHCS?.length; index++) {
    const element = sHCS[index];
    tempShops = [...tempShops, { shopCode: element.shopCode, text: element.title }];
  }
  const handelShops = (value) => {

    setShopCodeData(value);

    dispatch({ type: types.SET_SHOPCODE, shopCode: value })

    window.location.reload()
  }
  const renderCollapseElement = () => {
    if (collapsed) {
      return <FiAlignRight className="navIcon" onClick={onCollapse} />;
    } else {
      return <FiAlignLeft className="navIcon" onClick={onCollapse} />;
    }
  };

      if(state.shopCode == null ||  state?.shopCode==""){
        state.shopCode= tempShops.find(i => i.text == "فروشگاه پیش فرض").shopCode;
      }


  return (
    <>
      <Header className="navigation">
        {/* popover and dropdown styles that has placed out of wrapper */}


        {/* <Space size="small">{renderCollapseElement()}</Space> */}
        <Col xs={24} sm={12} md={6}>
          {/* {
            shopCodeData ?
              <CPSelect
                hasValidation
                name={shop}
                label={shop}
                dataSource={tempShops?.map(x => ({
                  value: x.shopCode, text: x.text
                }))}
                placeholder={"فروشگاه را انتخاب نمایید "}
                value={shopCodeData ? state.shopCode = shopCodeData : state.shopCode}
                // initialValue={shopCodeData ? state.shopCode = shopCodeData : state.shopCode}
                // defaultValue={tempShops.find(i=> i.text=="فروشگاه پیش فرض").shopCode}
                onChange={handelShops}
              /> :
              <CPSelect

                name={shop}
                label={shop}
                dataSource={tempShops?.map(x => ({
                  value: x.shopCode, text: x.text
                }))}
                placeholder={"فروشگاه را انتخاب نمایید "}
                value={state.shopCode ? state.shopCode : null}
                // defaultValue={tempShops.find(i=> i.text=="فروشگاه پیش فرض").shopCode}

                onChange={handelShops}
              />
          } */}
          {/* <CPSelect

            name={shop}
            label={shop}
            dataSource={tempShops?.map(x => ({
              value: x.shopCode, text: x.text
            }))}
            placeholder={"فروشگاه را انتخاب نمایید "}
            value={state.shopCode ? state.shopCode : null}
            onChange={handelShops}
          /> */}


          {/* <CPSelect

            name={shop}
            label={shop}
            dataSource={tempShops?.map(x => ({
              value: x.shopCode, text: x.text
            }))}
            placeholder={"فروشگاه را انتخاب نمایید "}
            value={state.shopCode ? state.shopCode : null}
            onChange={handelShops}
          /> */}


          <Select
            hasValidation
            name={shop}
            label={shop}
            style={{ width: "100%" }}

            // dataSource={tempShops?.map(x => ({
            //   value: x.shopCode, text: x.text
            // }))}
            placeholder={"فروشگاه را انتخاب نمایید "}
            //initialValue={state?.shopCode }
            defaultValue={state?.shopCode ? state?.shopCode : tempShops.find(i => i.text == "فروشگاه پیش فرض").shopCode}


            // initialValue={shopCodeData ? state.shopCode = shopCodeData : state.shopCode}
            // defaultValue={tempShops.find(i=> i.text=="فروشگاه پیش فرض").shopCode}
            onChange={handelShops}
          >
            {tempShops?.map(x => ({
              value: x.shopCode, text: x.text
            })).map((option) => (
              <Option key={option.value} value={option.value} label={option.text}>
                {option.text}
              </Option>
            ))}
          </Select>



        </Col>

        <Space size="small">
          <CPDropDown
            overlayCss="userInfo"
            menuList={userInfoDropDown}
            arrow
            placement="bottomLeft"
            onClick={(value) => handleChangeUserDropDown(value)}
            trigger={["click"]}
          >
            <span className="userInformation">
              <FiUser className="navIcon" />
              <small>{profileUser ? profileUser?.firstName + "-" + profileUser?.lastName : userInfo?.fullName}</small>
            </span>
          </CPDropDown>
        </Space>
      </Header>
      <CPModal
        title={renderTitleModal(typeAction)}
        visible={openModal}
        closable
        onCancel={() => setOpenModal(false)}
        footer={null}
        width={typeAction === "change_password" ? 300 : 600}
      >
        {renderModalComponent(typeAction)}
      </CPModal>
    </>
  );
};

export default Navigation;
